import { Switch, Route as ReactRoute } from 'react-router-dom'

import { lazyLoad } from 'components/ui/LazyLoad'
import { useAppDocMetaData } from 'hooks'
import { appRoutes, authRoutes, docsRoutes } from 'routes'
import ProtectedRoute from 'routes/components/ProtectedRoute'
import PublicRoute from 'routes/components/PublicRoute'
import { buildTime, version } from 'utils/appMeta'

import { BuyProvider } from '../../contexts/BuyContext'

const Profile = lazyLoad(() => import('views/profile/Profile'))

const App = () => {
  useAppDocMetaData({ version, buildTime })

  return (
    <BuyProvider>
      <Switch>
        <ProtectedRoute {...appRoutes.paymentRedirect} />
        <ProtectedRoute {...appRoutes.b2cRedirect} />
        <ReactRoute>
          <Switch>
            <ProtectedRoute exact {...appRoutes.main} />
            <ProtectedRoute exact {...appRoutes.contacts} />
            <ProtectedRoute exact {...appRoutes.about} />
            <ProtectedRoute exact {...appRoutes.faq} />

            {/*<ProtectedRoute exact {...appRoutes.blog} />*/}
            {/*<ProtectedRoute exact {...appRoutes.blogDetail} />*/}
            {/*<ProtectedRoute exact {...appRoutes.contributors} />*/}
            {/*<ProtectedRoute exact {...appRoutes.careers} />*/}
            {/*<ProtectedRoute exact {...appRoutes.careersDetail} />*/}

            <ProtectedRoute exact {...appRoutes.catalog} />
            <ProtectedRoute exact {...appRoutes.catalogDetailPhoto} />

            <ProtectedRoute {...appRoutes.buy} />
            <PublicRoute {...docsRoutes.docs} />
            <ProtectedRoute nonAuthorized {...authRoutes} />
            <ProtectedRoute authorized component={Profile} />
          </Switch>
        </ReactRoute>
      </Switch>
    </BuyProvider>
  )
}

export default App
